var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.5 21.5 8.5-4.25V8.5m-8.5 13-8-4.25V8.5m8 13V13M22 8.5 13.5 4l-8 4.5m16.5 0L13.5 13m-8-4.5 8 4.5M5 10H.5M5.5 13H3m-2 0H.5M5 16H2",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10 6 8 4.75v2.75",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPackage;